// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICipStatusSummaryRecordDto } from './ICipStatusSummaryRecordDto';
import {
    ICipStatusSummaryRecordDtoFromJSON,
    ICipStatusSummaryRecordDtoFromJSONTyped,
    ICipStatusSummaryRecordDtoToJSON,
    ICipStatusSummaryRecordDtoToJSONTyped,
} from './ICipStatusSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoCipStatusSummaryRecordDto
 */
export interface IReportSummaryGroupDtoCipStatusSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoCipStatusSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<ICipStatusSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoCipStatusSummaryRecordDto
     */
    subsidiary_records?: Array<ICipStatusSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoCipStatusSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoCipStatusSummaryRecordDto(value: object): value is IReportSummaryGroupDtoCipStatusSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoCipStatusSummaryRecordDto {
    return IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoCipStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(ICipStatusSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoCipStatusSummaryRecordDto {
    return IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoCipStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(ICipStatusSummaryRecordDtoToJSON)),
    };
}

